export enum SelectedComponentEnum {
    PERSONAL = "personal",
    TOKEN = "token",
    ELIGIBILITY = "eligibility",
    WAITING_VERIFICATION = "waitingVerification",
    ELIGIBILITY_DELAY = "eligibilityDelay",
    NO_AGREEMENT = "noAgreement",
    PAYMENT_AGREEMENT_TERM = "paymentAgreementTerm",
    REJECT_AGREEMENT = "rejectAgreement",
    ACCEPTANCE_AGREEMENT = "acceptanceAgreement",
    NO_ASSOCIATED_EMAIL = "noAssociatedEmail",
    NO_ASSOCIATED_CONTACT = "noAssociatedContact",
    AGREEMENT_EXPIRED = "agreementExpired",
    CURRENT_PAYMENT_AGREEMENT = "currentPaymentAgreement",
    GENERIC_ERROR = "genericError",
    CONFIRMATION_ERROR = "confirmationError",
}
export interface PaymentAgreement {
    error: string;
    message: string;
    status: boolean;
    code: number;
    data?: Data;
}
export interface Data {
    accountNumber?: number;
    value: number;
    valueMonths: number;
    months: number;
    dateExpirate: string;
    firstValue: string;
    error: string;
}

export enum PaymentAgreementError {
    EXPIRATE_PROCESS = "EXPIRATE_PROCESS",
    ERROR_PROCESS = "ERROR_PROCESS",
}
export interface PaymentAgreementDetails {
    agreement_id: number | string;
    date_accept: string;
    date_approve: string;
    date_expiration: string;
    date_start: string;
    documents: Documents[];
    months: string;
    parcels: Parcels[];
    simulation_id: string;
    status: string;
    value: string;
    value_months: string;
}
export interface Parcels {
    date: string;
    value: string;
}
export interface Documents {
    month: string;
    amount: string;
}

export interface ConfirmationContactResponse {
    code: number;
    contact: string;
    error: string;
    message: string;
    status: boolean;
}
